import api from './api'
import type { Page, PageListItem, PageInput } from '../types'

export const pagesService = {
  // Authenticated endpoints (for page owner)
  async getAllPages(): Promise<PageListItem[]> {
    const response = await api.get('/pages')
    return response.data.pages
  },

  async getPage(id: number): Promise<Page> {
    const response = await api.get(`/pages/${id}`)
    return response.data.page
  },

  async createPage(data: PageInput): Promise<Page> {
    const response = await api.post('/pages', { page: data })
    return response.data.page
  },

  async updatePage(id: number, data: PageInput): Promise<Page> {
    const response = await api.patch(`/pages/${id}`, { page: data })
    return response.data.page
  },

  async deletePage(id: number): Promise<void> {
    await api.delete(`/pages/${id}`)
  },

  async publishPage(id: number): Promise<Page> {
    const response = await api.post(`/pages/${id}/publish`)
    return response.data.page
  },

  async unpublishPage(id: number): Promise<Page> {
    const response = await api.post(`/pages/${id}/unpublish`)
    return response.data.page
  },

  async reorderPages(positions: { id: number; position: number }[]): Promise<void> {
    await api.post('/pages/reorder', { positions })
  },

  // Public endpoints
  async getPublicPages(username: string): Promise<PageListItem[]> {
    const response = await api.get(`/profiles/${username}/pages`)
    return response.data.pages
  },

  async getPublicPage(username: string, slug: string): Promise<Page> {
    const response = await api.get(`/profiles/${username}/pages/${slug}`)
    return response.data.page
  },
}
